import Vue from 'vue'
import vuetify from './plugins/vuetify'
import './plugins/base'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'
import CountryFlag from 'vue-country-flag'

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.component('country-flag', CountryFlag)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
